import styles from '../../../../common/preview-block/Preview.module.scss';
import React from 'react';

const Preview = () => {
  return (
    <div className={styles.template_preview_container}>
      <h2>Key Dates Overview</h2>
      <p>
        Track and manage <strong>important business deadlines and milestones</strong> automatically.
      </p>

      <p>
        Once you upload or create documents, the Key Dates feature extracts and highlights deadlines
        such as contract renewals, compliance filings, HR milestones, licence expiries, and other
        critical dates. These reminders appear in one place so you stay organised and avoid missed
        obligations.
      </p>
      <p>
        <strong>Risk of not using this:&nbsp;</strong>Missing key deadlines such as tax filings,
        licence renewals or contract expiries can lead to financial penalties, service disruptions
        or compliance violations.
      </p>
      <p>
        <strong>Tip:&nbsp;</strong>Review your Key Dates regularly and link them to your calendar or
        tasks so nothing slips through.
      </p>
    </div>
  );
};

export default Preview;
